import { SlotInfos } from '@/pages/cleaner_detail/components/TimeSlots';
import { Slot } from '../cleaners/model';
import dayjs from 'dayjs';

export enum BOOKING_ACTIONS {
  CREATE_NEW_BOOKING = 'CREATE_NEW_BOOKING',
  FETCH_BOOKINGS = 'FETCH_BOOKINGS',
  GET_BOOKING_DETAIL = 'GET_BOOKING_DETAIL',
  CLEANER_UPDATE_BOOKING = 'CLEANER_UPDATE_BOOKING',
  DELETE_REQUEST = 'DELETE_REQUEST',
  UPDATE_SERVICE = 'UPDATE_SERVICE',
  DELETE_CONFIRMED_BOOKING = 'DELETE_CONFIRMED_BOOKING',
  GET_PENDING_REVIEW_BOOKINGS = 'GET_PENDING_REVIEW_BOOKINGS',
}

export enum BOOKING_LOADERS {
  CREATE_NEW_BOOKING = 'CREATE_NEW_BOOKING',
  FETCH_BOOKINGS = 'FETCH_BOOKINGS',
  GET_BOOKING_DETAIL = 'GET_BOOKING_DETAIL',
  CLEANER_UPDATE_BOOKING = 'CLEANER_UPDATE_BOOKING',
  DELETE_REQUEST = 'DELETE_REQUEST',
  UPDATE_SERVICE = 'UPDATE_SERVICE',
  DELETE_CONFIRMED_BOOKING = 'DELETE_CONFIRMED_BOOKING',
  GET_PENDING_REVIEW_BOOKINGS = 'GET_PENDING_REVIEW_BOOKINGS',
}

export const generateCompletedSlots = (
  availableSlots: Slot[],
  selectedSlots: Slot[],
  newSlot: SlotInfos,
) => {
  const isRemovingSlot = newSlot.isSelected;
  const slotsTemplate = [...new Array(24)].map((_, index) => {
    const start = index;
    const end = index + 1;
    const isSelectable = availableSlots.some(
      ({ startTime, endTime }) => startTime === start && endTime === end,
    );
    const isCurrent = newSlot.startTime === start && newSlot.endTime === end;
    const isSelected = isCurrent
      ? !isRemovingSlot
      : selectedSlots.some(
          ({ startTime, endTime }) => startTime === start && endTime === end,
        );
    return { startTime: start, endTime: end, isSelectable, isSelected };
  });

  const itemIndex = newSlot.startTime;
  const selectedIndexes = slotsTemplate
    .map((slot, i) => (slot.isSelectable && slot.isSelected ? i : -1))
    .filter((i) => i !== -1);

  if (!selectedIndexes.length) return [];

  const minIndex = Math.min(...selectedIndexes);
  const isLeftSide =
    newSlot.startTime === (isRemovingSlot ? minIndex - 1 : minIndex);
  const maxIndex =
    isRemovingSlot && !isLeftSide
      ? itemIndex - 1
      : Math.max(...selectedIndexes);
  const range = slotsTemplate.slice(minIndex, maxIndex + 1);
  const isSkippingNotSelectable = range.some(
    ({ isSelectable }) => !isSelectable,
  );
  const startIndex =
    !isLeftSide && isSkippingNotSelectable ? newSlot.startTime : minIndex;
  const endIndex =
    isLeftSide && isSkippingNotSelectable ? newSlot.startTime : maxIndex;

  return slotsTemplate.reduce(
    (acc, { isSelectable, isSelected, ...rest }, index) => {
      if (
        (!isSkippingNotSelectable && isSelected && index <= startIndex) ||
        (index >= startIndex && index <= endIndex && isSelectable)
      ) {
        return [...acc, rest];
      }
      return acc;
    },
    [],
  );
};

export const getMessageByStatus = (startTime: string) => ({
  confirmed: `✅ Ho accettato la tua prenotazione, per il ${dayjs(startTime).format('DD/MM/YYYY')}! Non vedo l'ora di aiutarti.`,
  rejected: `❌ Mi dispiace, ho dovuto rifiutare la tua prenotazione per il ${dayjs(startTime).format('DD/MM/YYYY')}.`,
});

export const GROUP_BY_STATUS = {
  pending: 'pending',
  confirmed: 'confirmed',
  completed: 'confirmed',
  deleted: 'confirmed',
  rejected: 'rejected',
  started: 'confirmed',
};
